import type { ApiClient } from "@/clients/ApiClient";
import { fromEither } from "./compat";

export interface SubjectsApi {
    list(): Promise<Subject[]>;
    /** Throws when there is no such (published) subject */
    bySlug(slug: string): Promise<Subject>;
}

// The Go API leaves out empty text fields, the pages read them as strings
const normalize = (subject: Subject): Subject => ({
    ...subject,
    content: subject.content ?? "",
});

export const createSubjectsApi = (client: ApiClient): SubjectsApi => ({
    async list() {
        return fromEither<Subject[]>(await client.get("/subjects"), "subjects").map(normalize);
    },

    async bySlug(slug) {
        const subject = fromEither<Subject | null>(
            await client.get(`/subjects/${encodeURIComponent(slug)}`),
            "subject"
        );
        if (!subject) {
            throw new Error(`Subject not found: ${slug}`);
        }
        return normalize(subject);
    },
});
